import form from './form';

/**
 * 扩展form, 增加对审批流程的支持
 */
export default {
    extends: form,
    data() {
        return {
            baseUrl: null,
            statusField: null,
            idField: 'id',
            codeField: null,
            caller: null,
            form: {
                main: {}
            }
        };
    },
    methods: {
        /**
         * 预启动流程
         * @param {*} caller 
         * @param {*} dto 
         * @param {*} xtype 
         * @param {*} callback 
         */
        preLaunchProcess(caller, dto, xtype, callback) {
            var me = this;
            me.$loading({
                method: "post",
                url: "/api/process/instance/pre_launch",
                jsonData: {
                    bizType: caller,
                    bizId: dto.id,
                    bizCode: dto.code,
                    viewType: xtype
                }
            }).then(function (res) {
                if (res.success) {
                    if (res.data.approved) {
                        me.$weui.toast("审核成功", 2000);
                        callback.call(me, dto);
                    } else if (res.data.launched) {
                        me.$weui.toast("提交成功", 2000);
                        callback.call(me, dto);
                    } else if (res.data.warnMessage) {
                        me.$weui.confirm(res.data.warnMessage + '，是否继续提交？', function () {
                            if (res.data.items) {
                                me.selectNodeHandler(res.data.items, function (selectedUserMap) {
                                    me.launchProcess(caller, dto, selectedUserMap, xtype, res.data.warnMessage, callback);
                                });
                            } else {
                                me.launchProcess(caller, dto, {}, xtype, res.data.warnMessage, callback);
                            }
                        });
                    } else if (res.data.items) {
                        me.selectNodeHandler(res.data.items, function (selectedUserMap) {
                            me.launchProcess(caller, dto, selectedUserMap, xtype, null, callback);
                        });
                    }
                } else if (res.code == 80001) {
                    me.$weui.toast("保存成功", 2000);
                    // 无流程规则的情况
                    callback.call(me, dto);
                } else {
                    me.$weui.topTips(res.message, 3000);
                }
            });
        },
        selectNodeHandler(unselected, callback) {
            var me = this;
            me.$loading({
                url: "/api/account/account/list"
            }).then(function (res) {
                if (res.success) {
                    var options = res.data.map(o => {
                        return Object.assign(o, {
                            label: o.realname,
                            value: o.id
                        });
                    });
                    var selectedUserMap = {},
                        fn = function (i) {
                            var unselect = unselected[i];
                            if (unselect.handlerType == 1) {
                                var config = {
                                    title: `请指定节点${i + 1}「${unselect.name}」审批人`,
                                    onConfirm: function (r) {
                                        if (r.length) {
                                            selectedUserMap[unselect.id] = [r[0].id];
                                        }
                                    },
                                    onClose: function () {
                                        if (i < unselected.length - 1) {
                                            fn(i + 1);
                                        } else {
                                            callback.call(me, selectedUserMap);
                                        }
                                    }
                                };
                                if (unselect.handlerList && unselect.handlerList.length) {
                                    config.defaultValue = [unselect.handlerList[0].id];
                                }
                                me.$weui.picker(options, config);
                            } else {
                                selectedUserMap[unselect.id] = unselect.handler.split(',');
                                if (i < unselected.length - 1) {
                                    fn(i + 1);
                                } else {
                                    callback.call(me, selectedUserMap);
                                }
                            }
                        };
                    fn(0);
                }
            });
        },
        /**
         * 启动流程
         * @param {*} caller 
         * @param {*} dto 
         * @param {*} selectedUserMap 
         * @param {*} xtype 
         * @param {*} callback 
         */
        launchProcess(caller, dto, selectedUserMap, xtype, warnMessage, callback) {
            var me = this;
            me.$loading({
                method: "post",
                url: '/api/process/instance/launch',
                jsonData: {
                    bizType: caller,
                    bizId: dto.id,
                    bizCode: dto.code,
                    viewType: xtype,
                    warnMessage,
                    selectedUserMap
                }
            }).then(function (res) {
                if (res.success) {
                    me.$weui.toast("保存成功", 2000);
                    callback.call(me, dto);
                } else {
                    me.$weui.topTips(res.message, 3000);
                    callback.call(me, dto);
                }
            }).catch(function () {
                me.$weui.topTips("保存失败", 3000);
            });
        },
        /**
         * 反提交取消流程
         */
        cancelProcess(caller, id, code, callback) {
            var me = this;
            me.$loading({
                url: '/api/process/instance/cancel',
                method: 'POST',
                params: {
                    bizType: caller,
                    bizId: id,
                    bizCode: code
                }
            }).then(function (res) {
                if (res.success) {
                    callback.call(me);
                } else {
                    me.$weui.topTips("反提交失败: " + res.message, 3000);
                }
            }).catch(function () {
                me.$weui.topTips("反提交失败", 3000);
            });
        },
        /**
         * 保存/更新业务单据，如果已提交则先反提交，保存完后自动提交
         * @param {*} callback 
         * @param {*} caller 
         * @param {*} id 
         * @param {*} code 
         * @param {*} xtype 
         */
        p_save(callback, caller, id, code, xtype) {
            var me = this, main = me.form.main, s;
            caller = caller || me.caller;
            id = id || main[me.idField];
            code = code || main[me.codeField];
            xtype = xtype || me.xtype;
            if (me.statusField) {
                s = main[me.statusField];
                if (['SUBMITTED', '已提交'].indexOf(s) != -1) {
                    me.cancelProcess(caller, id, code, function () {
                        me.doSaveBiz(callback, caller, xtype);
                    });
                } else {
                    me.doSaveBiz(callback, caller, xtype);
                }
            } else {
                me.doSaveBiz(callback, caller, xtype);
            }
        },
        doSaveBiz(callback, caller, xtype) {
            var me = this;
            me.f_save(function (res) {
                me.preLaunchProcess(
                    caller,
                    res.data,
                    xtype,
                    function () {
                        if (callback && typeof callback === 'function') {
                            callback.call(me, res);
                        } else {
                            me.p_router_to_read(res.data.id);
                        }
                    }
                );
            });
        },
        p_router_to_read(id) {
            var me = this, isUpdate = me.initId || me.$route.params.id || me.$route.query.id;
            if (isUpdate) {
                // 默认跳转回
                me.$router.back();
            } else {
                var editName = me.$route.name,
                    readName = editName.substr(0, editName.length - 4);
                // 打开查看页
                setTimeout(function () {
                    me.$router.push({
                        name: readName,
                        params: {
                            id: id
                        }
                    });
                }, 100);
            }
        },
        /**
         * 删除单据，如果已提交则先反提交
         * @param {*} callback 
         * @param {*} caller 
         * @param {*} id 
         * @param {*} code 
         */
        p_remove(callback, caller, id, code) {
            var me = this, main = me.form.main, s;
            caller = caller || me.caller;
            id = id || main[me.idField];
            code = code || main[me.codeField];
            me.$weui.confirm('确定删除单据？', function () {
                if (me.statusField) {
                    s = main[me.statusField];
                    if (['SUBMITTED', '已提交'].indexOf(s) != -1) {
                        me.cancelProcess(caller, id, code, function () {
                            me.f_delete(callback, id);
                        });
                    } else {
                        me.f_delete(callback, id);
                    }
                } else {
                    me.f_delete(callback, id);
                }
            });
        }
    }
}